"use client";
import { getColorName } from "@/functions/fns";
import useThrottle from "@/hooks/useThrottle";
import { useState, useEffect } from "react";
import LoaderSkeleton from "./LoaderSkeleton";

export default function ColorName({ hsla, fallBack, customLoading }) {
	const [alias, setAlias] = useState("");
	const [loading, setLoading] = useState(true);

	const throttledHsla = useThrottle(hsla, 1000);

	const loadingAction = customLoading || setLoading;

	useEffect(() => {
		loadingAction(true);
		const loadName = async () => {
			try {
				const cName = await getColorName(throttledHsla);
				setAlias(cName);
				setTimeout(() => loadingAction(false), 200);
			} catch (err) {
				setAlias(fallBack);
				loadingAction(false);
			}
		};

		loadName();
	}, [throttledHsla, fallBack, loadingAction]);

	const loadingCheck = customLoading ? false : loading;
	return (
		<>
			{loadingCheck && <LoaderSkeleton els={1} />}
			<div className="hu flex items-center">{alias}</div>
		</>
	);
}
